export const SEARCH_DEBOUNCE_VALUE = 100;
